import usePolarisActor from 'src/hooks/usePolarisActor';

type TransitionOptions = {
  data?: any;
  event: string;
  /** Subactor ID to transition to */
  id?: string;
};

const useParentTransition = () => {
  const actor = usePolarisActor();

  return (options: TransitionOptions) => {
    const { data, event, id } = options;

    (actor as any)?.parent?.send({ type: event, data, id });
  };
};

export default useParentTransition;
